// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export default from './FileEditor';



// WEBPACK FOOTER //
// ./views/smb/file-manager/index.js